import { styled } from "@mui/material"
import {
  type ApiUniverseSales,
  CollapsibleBlock,
  CollapsibleGroup,
  type Period,
  type SafeApiComponentProps,
  type SalesDistribution,
} from "@pharmupp/p3-front-commons"
import { UniversesChips } from "./SaleChips"
import { SalesGrid } from "./components"

const CARD_TO_DISPLAY = 4

interface SalesUniverseSectionProps extends ApiUniverseSales {
  distribution: SalesDistribution
  period: Period
}

export const SalesUniverseSection = ({
  distribution,
  period,
  universes,
}: SalesUniverseSectionProps) => (
  <CollapsibleGroup labels={{ less: "Moins d'univers", more: "Plus d'univers" }}>
    <SalesGrid>
      <UniversesChips
        universes={universes.slice(0, CARD_TO_DISPLAY)}
        distribution={distribution}
        period={period}
      />
      <StyledCollapsibleBlock>
        <SalesGrid>
          <UniversesChips
            universes={universes.slice(CARD_TO_DISPLAY)}
            distribution={distribution}
            period={period}
          />
        </SalesGrid>
      </StyledCollapsibleBlock>
    </SalesGrid>
  </CollapsibleGroup>
)

SalesUniverseSection.suspense = {
  skeletonProps: { height: 300 },
} satisfies SafeApiComponentProps["suspense"]

const StyledCollapsibleBlock = styled(CollapsibleBlock)({
  gridColumn: "1 / -1",
})
